import { WEATHER_DETAIL_ICON_KEYS } from 'features/Weather/config/weatherDetailIcons.config';
import { BsFire } from 'react-icons/bs';
import { FaFire, FaFireFlameSimple } from 'react-icons/fa6';

/**
 * Defines the information displayed inside each Fire Danger card.
 *
 * The API provides the report values. This configuration tells the shared
 * TimePeriodCard component how to display those values.
 *
 * Each detail contains:
 * - id: A stable name React uses to identify the row.
 * - label: The text the user sees beside the value.
 * - iconKey: The icon to use from our existing Weather icon collection.
 * - getValue: A function that reads this detail from one API report.
 */
export const fireDangerDetails = [
  {
    id: 'riskLevel',
    label: 'Risk Level',
    iconKey: WEATHER_DETAIL_ICON_KEYS.ALERT,
    getValue: (report) => report?.level,
  },
  {
    id: 'upperSoilMoisture',
    label: 'Upper Soil Moisture',
    iconKey: WEATHER_DETAIL_ICON_KEYS.HUMIDITY,
    getValue: (report) => report?.upper_soil_moisture,
  },
  {
    id: 'lowerSoilMoisture',
    label: 'Lower Soil Moisture',
    iconKey: WEATHER_DETAIL_ICON_KEYS.HUMIDITY,
    getValue: (report) => report?.lower_soil_moisture,
  },
];

export const fireDangerIconComponents = {
  0: FaFireFlameSimple,
  1: FaFire,
  2: BsFire,
  3: BsFire,
  4: BsFire,
};

/** Selects the card's risk color. The shared TimePeriodCard styles turn it into a gradient. */
export const fireDangerCardClassNames = {
  0: 'fire-danger-risk-very-low',
  1: 'fire-danger-risk-low',
  2: 'fire-danger-risk-moderate',
  3: 'fire-danger-risk-high',
  4: 'fire-danger-risk-extreme',
};
